var _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScadaLinkMaster(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "200px",
    viewBox: "0 -0.08 0.6 4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.02,
    strokeMiterlimit: 22.9256
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.21,
    y1: 1.87,
    x2: 0.21,
    y2: 4.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.21,
    y1: 1.87,
    x2: 0.21,
    y2: 4.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.21,
    y1: 0.75,
    x2: 0.21,
    y2: 1.49
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.21 1.87c0.11,0 0.19,-0.09 0.19,-0.19 0,-0.11 -0.08,-0.19 -0.19,-0.19"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.21,
    cy: 0.21,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.21,
    cy: 0.55,
    r: 0.2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0.21,0.1 0.31,0.27 0.12,0.27"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "0.36,0.69 0.21,0.57 0.21,0.42 0.21,0.57 0.07,0.69 "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "black",
    stroke: "black",
    strokeWidth: 0.01
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.21,
    cy: 1.49,
    r: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.21,
    cy: 1.87,
    r: 0.05
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScadaLinkMaster);
export default __webpack_public_path__ + "static/media/scada_link_master.4a3de346.svg";
export { ForwardRef as ReactComponent };